// 부트스트랩 설정.
const $ = require('jquery');
window.$ = window.jQuery = $;
window.$.datepicker = require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/sortable');
window.$.selectize = require('selectize');
window.Popper = require('popper.js');
window.feather = require("feather-icons");
window.axios = require('axios');
window.Vue = require('vue').default;
window.ToastUiEditor = require('@toast-ui/editor');

// 스와이퍼 설정.
import Swiper from 'swiper/bundle';
// 슬릭 설정.
import slick from 'slick-carousel';
import "jquery-mask-plugin/dist/jquery.mask.min";

import moment from "moment"
// 이미지맵 리사이징.
import ImageMap from "image-map";

import AddressSearch from './components/AddressSearch.vue';
import EasyAddressSearch from './components/EasyAddressSearch.vue';
import "./push/push";
import {startTimer} from './utils/timer';

window.Swiper = Swiper;

window.slick = slick;

window.push = require("./push/push").default;

window.Vue.component('address-search', AddressSearch);
window.Vue.component('easy-address-search', EasyAddressSearch);

window.startTimer= startTimer;

window.Swiper = Swiper;
window.moment = moment;

require('bootstrap');
// require('@babel/polyfill');

window.mwHelper = require("./helper").default;

import { Wheel } from 'spin-wheel';
window.Wheel = Wheel;

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import koLocale from '@fullcalendar/core/locales/ko';

window.FullCalendar = {
    Calendar,
    dayGridPlugin,
    interactionPlugin,
    koLocale
};

// 아이콘 설정.
document.addEventListener("DOMContentLoaded", () => {
    feather.replace();
    $('[data-toggle="tooltip"]').tooltip();
    ImageMap('img[usemap]');

    $("body").on("click", ".popup-open", function (e) {
        e.preventDefault();

        const me = $(this);
        let url = me.data("url");
        let name = me.data("name");
        let width = parseInt(me.data("width"));
        let height = parseInt(me.data("height"));
        let top = parseInt(me.data("top"));
        let left = parseInt(me.data("left"));

        mwHelper.openPopup(url, width, height, top, left, name);
    }).on("mouseenter", "table.table-row-bg tbody td", function () {
        const $tr = $(this).parent();
        $(".table-row-bg tr[data-key=" + $tr.data("key") + "] td").addClass("td-mouseover-bg");
    }).on("mouseleave", "table.table-row-bg tbody td", function () {
        const $tr = $(this).parent();
        $(".table-row-bg tr[data-key=" + $tr.data("key") + "] td").removeClass("td-mouseover-bg");
    });

    // -----------------------------
    // 1) 마스크 규칙 함수들
    // -----------------------------
    const mask_hp = (v) => {
        const masks = ['000-0000-0000', '000-000-00009'];
        return (String(v || '').replace(/[^0-9]/g, "").length === 10) ? masks[1] : masks[0];
    };

    const mask_tel = (v) => {
        const masks = [
            '00-000-0000999',
            '000-000-000099',
            '000-0000-00009',
            '0000-0000-0000',
        ];

        let mask = masks[0];
        switch (String(v || '').replace(/[^0-9]/g, "").length) {
            case 10: mask = masks[1]; break;
            case 11: mask = masks[2]; break;
            case 12: mask = masks[3]; break;
        }
        return mask;
    };

    // -----------------------------
    // 2) 신규 DOM만 마스크 적용 (root 범위 지원)
    // -----------------------------
    function applyInputMasks(root = document) {
        // 휴대폰
        $(root).find('.mask-hp').each(function () {
            const $el = $(this);

            // ✅ 신규 요소만 처리
            if ($el.data('__mask_hp_applied') === true) return;
            $el.data('__mask_hp_applied', true);

            // 기존 마스크 제거(안전)
            if (typeof $el.unmask === 'function') $el.unmask();

            $el.mask(mask_hp($el.val()), {
                onKeyPress: function (cep, e, field, options) {
                    field.mask(mask_hp(cep), options);
                }
            });
        });

        // 전화번호
        $(root).find('.mask-tel').each(function () {
            const $el = $(this);

            // ✅ 신규 요소만 처리
            if ($el.data('__mask_tel_applied') === true) return;
            $el.data('__mask_tel_applied', true);

            if (typeof $el.unmask === 'function') $el.unmask();

            $el.mask(mask_tel($el.val()), {
                onKeyPress: function (cep, e, field, options) {
                    field.mask(mask_tel(cep), options);
                }
            });
        });
    }

    // 최초 1회 (현재 DOM)
    applyInputMasks(document);

    // -----------------------------
    // 3) Vue v-if 등으로 "나중에 추가된 DOM" 자동 감지
    // -----------------------------
    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (node.nodeType !== 1) continue; // element만

                // ✅ 추가된 덩어리(node) 안에서만 스캔해서 신규만 적용
                applyInputMasks(node);
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // -----------------------------
    // 4) (선택) 전역에서 수동 재적용 API 제공
    //    - 혹시 특정 영역만 강제로 다시 적용하고 싶을 때
    // -----------------------------
    window.mwApplyInputMasks = applyInputMasks;

    function isAndroid(){ return /Android/i.test(navigator.userAgent || ""); }
    function isIOS(){ return /iPhone|iPad|iPod/i.test(navigator.userAgent || ""); }

    $(".deeplink").on("click", function (e) {
        e.preventDefault();

        const $el = $(this);
        const web      = $el.attr("href") || "/";
        const iosApp   = $el.data("ios");
        const iosStore = $el.data("iosStore");
        const andUrl   = $el.data("android");
        const andPlay  = $el.data("androidPlay");
        const t = parseInt($el.data("timeout"), 10);
        const timeout  = (Number.isFinite(t) && t > 0) ? t : 2000;

        if (isAndroid()) {
            if (andUrl) {
                let appOpened = false;

                const visibilityHandler = () => {
                    if (document.hidden) appOpened = true;
                };

                document.addEventListener("visibilitychange", visibilityHandler);
                window.location.href = andUrl;

                setTimeout(() => {
                    document.removeEventListener("visibilitychange", visibilityHandler);
                    if (!appOpened && !document.hidden) {
                        window.location.href = andPlay || web;
                    }
                }, timeout);
            } else if (andPlay) {
                window.location.href = andPlay;
            } else {
                window.location.href = web;
            }
            return;
        }

        if (isIOS()) {
            if (iosApp) {
                let appOpened = false;

                const visibilityHandler = () => {
                    if (document.hidden) appOpened = true;
                };

                document.addEventListener("visibilitychange", visibilityHandler);
                window.location.href = iosApp;

                setTimeout(() => {
                    document.removeEventListener("visibilitychange", visibilityHandler);
                    if (!appOpened) {
                        window.location.href = iosStore || web;
                    }
                }, timeout);
            } else if (iosStore) {
                window.location.href = iosStore;
            } else {
                window.location.href = web;
            }
            return;
        }

        window.location.href = web;
    });
});

// 크로스 사이트 처리를 위한 코드.
// 다른 도메인의 사이트에서 데이터를 전달 받음.
window.addEventListener('message', function (e) {
    if (e.data.callback) {
        // ...처리 로직 (부모창 함수 호출)
        window[e.data.callback](e.data.arguments);
    }
});


/**
 * 지도 검색.
 * @param callback
 */
window.search_address = function (callback) {
    const callbackName = "cb" + Math.round((Math.random() * 1000000000));
    const url = webRoot + "areas/search?callback=" + callbackName + "&delivery_charge=on";
    const width = 550;
    const left = (screen.availWidth - width) / 2;

    window[callbackName] = function (data) {
        let deliveryCharge = data.deliveryCharge;

        if (typeof deliveryCharge == "string") {
            deliveryCharge = parseInt(deliveryCharge);
        }

        callback({
            address: data.address,
            address_detail: data.detail,
            zipcode: data.zipcode || '00000',
            deliveryCharge: deliveryCharge,
        });
    };

    const popup = window.open(
        url,
        callbackName,
        "scrollbars=1,resizable=1,width=" + width + ",height=550,top=100,left=" + left
    );

    return !(!popup || popup.closed || typeof popup.closed === "undefined");
};

// 클립보드로 텍스트 복사.
window.copy_to_clipboard = function (val) {
    if (!document.execCommand) {
        alert("클립보드로 복사가 지원되지 않는 브라우저입니다.");
        return false;
    }

    const t = document.createElement("textarea");
    document.body.appendChild(t);
    t.value = val;
    t.select();
    document.execCommand('copy');
    document.body.removeChild(t);
    return true;
}

window.loadScript = function (FILE_URL, async = true, type = "text/javascript") {
    return new Promise((resolve, reject) => {
        try {
            const scriptEle = document.createElement("script");
            scriptEle.type = type;
            scriptEle.async = async;
            scriptEle.src = FILE_URL;

            scriptEle.addEventListener("load", (ev) => {
                resolve({status: true});
            });

            scriptEle.addEventListener("error", (ev) => {
                reject({
                    status: false,
                    message: `Failed to load the script ${FILE_URL}`
                });
            });

            document.body.appendChild(scriptEle);
        } catch (error) {
            reject(error);
        }
    });
};

//WebView 뒤로가기: 모달이 열려있으면 모달부터 닫기 (Bootstrap + Vue 공통)
(function () {
    let ignoreNextPop = false;

    function closeBootstrapModalIfOpen() {
        const $open = $('.modal.show:visible').last();
        if ($open.length) {
            $open.modal('hide');
            return true;
        }
        return false;
    }

    function requestCloseVueModal() {
        window.dispatchEvent(new CustomEvent('close-any-vue-modal'));
    }

    $(document).on('shown.bs.modal', '.modal', function () {
        history.pushState({ __modal: true }, '');
    });

    $(document).on('hidden.bs.modal', '.modal', function () {
        if (!ignoreNextPop && history.state && history.state.__modal) {
            ignoreNextPop = true;
            history.back();
        }
    });

    window.addEventListener('popstate', function () {
        if (ignoreNextPop) {
            ignoreNextPop = false;
            return;
        }

        if (closeBootstrapModalIfOpen()) return;

        requestCloseVueModal();
    });
})();

